document.querySelectorAll('select.form-control').forEach(select => {
  // Hide the <option value=""> (placeholder)
  const placeholderOption = select.querySelector('option[value=""]');
  if (placeholderOption) {
    placeholderOption.hidden = true;
  }

  // Define a function to update color based on selection
  function updateColor() {
    if (select.value === '') {
      select.style.color = 'gray';
    } else {
      select.style.color = '';
    }
  }

  // Set initial color on page load
  updateColor();

  // Add change event listener
  select.addEventListener('change', updateColor);
});
